<template>
    <div class="scroll-container">
        <a-button class="top_btn" type="primary"  @click="()=>{visiblezd = true;}" v-has="'btn_batch_add'"> 批量添加字段 </a-button>
        <a-table
                :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
                :columns="columns"
                :data-source="data"
                :loading="loading"
                rowKey="id"
                :pagination="pagination"
        >
            <span slot="action" slot-scope="text, record">
                <i v-if="$_hasAll(['btn_edit_language','btn_edit','btn_delete'])" style="color:#838383">暂无操作权限</i>
        <a @click="(record)=>{visibleForm = true; fieldId={a_langset_field_id:text.id,a_langset_field_name:text.name} ; titleForm='编辑语种内容' }" class="btntable" v-has="'btn_edit_language'">编辑语种内容<a-divider type="vertical"/></a>
        <a @click="(record)=>{visiblebj = true; editId=text.id ;getzdname() }" class="btntable" v-has="'btn_edit'">编辑<a-divider type="vertical"/></a>
          <a-popconfirm
                  title="此操作将永久删除, 是否继续?"
                  ok-text="确定"
                  cancel-text="取消"
                  @confirm="confirm(record)"
                  @cancel="()=>{}"  >
   <a v-has="'btn_delete'">删除</a>
  </a-popconfirm>
      </span>
        </a-table>
        <a-drawer
                title="批量添加字段"
                placement="right"
                :visible="visiblezd"
                @close="onClose"
                :width="600"
                v-bind="drawerConfig"
                :destroyOnClose="true"
                :body-style="{ paddingBottom: '80px' }"
        >
            <a-form-model
                    ref="ruleForm"
                    :model="form"
                    :rules="rules"
                    :label-col="labelCol"
                    :wrapper-col="wrapperCol"

            >
                <a-form-model-item ref="name" label="批量添加字段" prop="name" :help="formErr.name"
                                   :validateStatus='!formErr.name||formErr.name ==""?"":"error"'>
                    <a-textarea :maxLength=200 :rows="4" v-model="form.name"
                                @change="(e) => { formErr.name='' }"
                                @blur="(e) => {  form.name = e.target.value.trim() }"/>
                    <span>每行填写一个字段</span>
                </a-form-model-item>
            </a-form-model>
            <div class="drawer-btn"  >

                <a-button type="primary" @click="onSubmit" :style="{ marginRight: '8px' }" >
                    确定
                </a-button>
                <a-button @click="onClose">
                取消
            </a-button>
            </div>
        </a-drawer>
        <a-drawer
                title="编辑字段"
                placement="right"
                :visible="visiblebj"
                @close="onClose"
                :width="600"
                :destroyOnClose="true"
                :body-style="{ paddingBottom: '80px' }"
        >
            <a-form-model
                    ref="ruleFormzd"
                    :model="formzd"
                    :rules="ruleszd"
                    :label-col="labelCol"
                    :wrapper-col="wrapperCol"
            >
                <a-form-model-item ref="name" label="字段名称" prop="name" :help="formErrzd.name"
                                   :validateStatus='!formErrzd.name||formErrzd.name ==""?"":"error"'>
                    <a-input v-model="formzd.name" @change="(e) => { formErrzd.name='' }"
                             :maxLength="50"
                             @blur="(e) => {  formzd.name = e.target.value.trim() }"/>
                </a-form-model-item>

                <a-form-model-item ref="abstract" label="字段描述" prop="abstract" :help="formErrzd.abstract"
                                   :validateStatus='!formErrzd.abstract||formErrzd.abstract ==""?"":"error"'>
                    <a-input v-model="formzd.abstract" @change="(e) => { formErrzd.abstract='' }" type="textarea"  @blur="(e) => {  formzd.abstract = e.target.value.trim() }"/>
                </a-form-model-item>
            </a-form-model>
            <div class="drawer-btn"  >

                <a-button type="primary" @click="onSubmitzd" :style="{ marginRight: '8px' }" >
                    确定
                </a-button>
                <a-button @click="onClose">
                取消
            </a-button>
            </div>
        </a-drawer>
        <FieldForm :visible="visibleForm" :title="titleForm" :editId="fieldId"
                  @changVisible=" () => { this.visibleForm = false;this.fieldId='';  this.getList(pageNum)}  "></FieldForm>
    </div>
</template>
<script>
    import {submitForm,drawerConfig,validator,changStatus, removeById,orderList} from "../../../../utils/utils"
    import API from "../api"
    import FieldForm from "./fieldForm"
    const columns =  [
        {
            title: "ID",
            dataIndex: "id",
            key: "id",
            width: "8%",
        },
        {
            title: "字段名称",
            dataIndex: "name",
            ellipsis: true,
            key: "name",
        },
        {
            title: "字段描述",
            dataIndex: "abstract",
            ellipsis: true,
            key: "abstract",
        },
        {
            title: "添加时间",
            key: "create_time",
            ellipsis: true,
            dataIndex: "create_time",
        },
        {
            title: "操作",
            key: "action",
            width: "250px",
            scopedSlots: {customRender: "action"}
        }
    ];
    export default {
        name: "fieldList",
        data(){
            return{
                drawerConfig,
                pageNum:"",
                visiblezd:false,
                visiblebj:false,
                visibleForm: false,
                titleForm: "",
                editId: null,
                fieldId:null,
                pagination: {
                    pageNo: 1,
                    pageSize: 20, // 默认每页显示数量
                    onShowSizeChange: (pageSize) => (this.pageSize = pageSize), // 改变每页数量时更新显示
                    onChange: this.getList.bind(this), //点击页码事件
                    total: 0, //总条数
                    current: 0,
                    size: "small",
                    showTotal: total => `共 ${total} 条`,
                    showQuickJumper: true
                },
                data:[],
                columns,
                selectedRowKeys: [], // Check here to configure the default column
                loading: true,
                sortLists:[],
                labelCol: {span: 6},
                wrapperCol: {span: 14},
                formErr: { name: "",  },
                form: { name: "",   },
                formErrzd: { name: "", abstract:"" },
                formzd: { name: "",abstract:""   },
                rules: {
                    name: [ {required: true, message: '请填写字段'},{validator:(rule, value, callback)=>{validator(rule, value, callback,this.formErr.name)}  , trigger: "blur"  }, ],
                    },
                ruleszd: {
                    name: [ {required: true, message: '请填写字段'},{validator:(rule, value, callback)=>{validator(rule, value, callback,this.formErrzd.name)}  , trigger: "blur"  }, ],
                },
            }
        },

        components:{FieldForm},

        mounted(){
            this.getList()
        },
        methods: {
            onClose() {
                this.visiblezd = false;
                this.visiblebj = false;
                this.formErr.name=""
                this.form.name=""
                this.formErrzd.name=""
                this.formzd.name=""
                this.formzd={ name: "",abstract:""   }
            },
            getList(page) {
                this.pageNum=page
                API.field.GET_LIST(page||1).then(res => {
                    this.pagination.total=res.data.data.total
                    this.pagination.pageSize=res.data.data.per_page
                    this.pagination.current=res.data.data.current_page
                    this.data = res.data.data.data
                    this.loading = false
                })
            },
            getzdname() {
                API.field.GET_DATA(this.editId).then(res => {
                    this.formzd=res.data.data.info
                })
            },
            onSubmitzd(){
                let _this = this;
                this.$refs.ruleFormzd.validate(valid => {
                    if (valid) {
                        submitForm(API.field.SUBMIT_ZDDATA, _this.formzd).then(res => {
                            if (res == true) {
                                this.onClose()
                                this.getList(this.pageNum)
                            } else {
                                res.map((item, index) => {
                                    this.formErrzd[item.field] = item.msg
                                })
                            }
                        })
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
            onSubmit() {
                let _this = this;
                this.$refs.ruleForm.validate(valid => {
                    if (valid) {
                        submitForm(API.field.SUBMIT_ADDLIST, _this.form).then(res => {
                            if (res == true) {
                                this.onClose()
                                this.getList()
                            } else {
                                res.map((item, index) => {
                                    this.formErr[item.field] = item.msg
                                })
                            }
                        })
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
            confirm(row) {
                removeById(API.field.DELE, [row.id]).then(res => {
                    if (res == true) {
                        this.getList()
                    }
                })
            },
            start() {
                this.loading = true;
                API.language.DELE( this.selectedRowKeys).then(res => {
                    this.getList()
                    this.loading = false;
                    this.selectedRowKeys = [];
                })
            },
            onSelectChange(selectedRowKeys) {
                this.selectedRowKeys = selectedRowKeys;
            },
        },
    }
</script>

<style scoped>
    .btntable{margin-right: 10px}
    .inputs {
        display: inline-block;
        width: 70px
    }
    .scroll-container{height: calc(100vh - 250px);overflow: auto}
    .scroll-container::-webkit-scrollbar { width: 8px; background: white;  }
    .scroll-container::-webkit-scrollbar-corner, .scroll-container::-webkit-scrollbar-thumb, .scroll-container::-webkit-scrollbar-track { border-radius: 4px; }
    .scroll-container::-webkit-scrollbar-corner,.scroll-container::-webkit-scrollbar-track {  background-color: #ddd; box-shadow: inset 0 0 1px #ddd; }
    .scroll-container::-webkit-scrollbar-thumb {  background-color: #c1c1c1; }

</style>
